<template>
    <div class="page search-list">
        <div class="search">
            <van-search ref="search_input" v-model="value" :autofocus="autofocus" show-action @search="onSearch" @cancel="onCancel" placeholder="搜一搜">
                <template slot="action">
                    <div class="search-list-action" @click="onSearch">搜索</div>
                </template>
            </van-search>
        </div>

        <div class="tags" v-if="(course.length + live.length + article.length + short_video.length) > 0">
            <van-tabs v-model="category_index" @click="onSearch" swipeable>
                <van-tab :title-class="'course-list-category-title'" v-for="(item,index) in categories" :key="item.id" :title="item.name" :disabled="item.name==''" />
            </van-tabs>
            <div class="clear"></div>
        </div>

        <div class="search-list-section" v-if="course.length > 0">
            <div class="search-list-title">相关课程<span @click="$router.push({name:'course-list'})">查看更多<img src="/static/img/icon_more.svg" alt=""></span></div>
            <div class="course-list-section" style="margin-top: 22px">
                <van-row @click="go_detail(item)" v-for="item in course" :key="item.id">
                    <div class="course-list-section-box">
                        <div class="course-list-section-left">
                            <img class="course-list-section-left-img" :src="item.cover_img">
                            <img v-if="item.type==2" class="course-list-section-left-zl"
                                 src="/static/img/icon_list_tag_column.svg" alt="">
                        </div>
                        <div class="course-list-section-right">
                            <div class="course-list-section-right-title" v-html="item.title"></div>
                            <div class="course-list-section-right-author" v-if="item.type != 2">{{item.doctor}} ·
                                {{item.hospital}}
                            </div>
                            <div class="course-list-section-right-author" v-else>{{item.course_desc}}</div>
                            <div class="course-list-section-right-detail">{{item.view_count}}人学习</div>
                        </div>
                    </div>
                </van-row>
            </div>
        </div>

        <div class="search-list-section" v-if="live.length > 0">
            <div class="search-list-title">相关直播<span @click="$router.push({name:'live-list'})">查看更多<img src="/static/img/icon_more.svg" alt=""></span></div>
            <div class="live-list-section">
                <van-row @click="go_live_detail(item)" v-for="item in live" :key="item.id">
                    <div class="live-list-section-box">
                        <div class="live-list-section-left">
                            <img class="live-list-section-left-img" :src="item.cover_img">
                            <img v-if="item.type === 2" class="live-list-section-left-zl"
                                 src="/static/img/icon_list_tag_column.svg" alt="">
                            <img v-else-if="item.live_status===0" class="live-list-section-left-zl"
                                 src="/static/img/live/icon_list_tag_live_count_down.svg" alt="">
                            <img v-else-if="item.live_status===1" class="live-list-section-left-zl"
                                 src="/static/img/live/icon_list_tag_live_process.svg" alt="">
                            <img v-else-if="item.live_status>2" class="live-list-section-left-zl"
                                 src="/static/img/live/icon_list_tag_live_history.svg" alt="">
                            <div class="live-list-section-left-time" v-if="item.live_status>1"><span>{{item.duration_format}}</span></div>
                        </div>
                        <div class="live-list-section-right">
                            <div class="live-list-section-right-title" v-html="item.title"></div>
                            <div class="live-list-section-right-detail">
                                <span v-if="item.type === 2">{{item.live_desc}}</span>
                                <span v-else-if="item.live_status < 2">{{item.start_at}}</span>
                                <span v-else>{{item.view_count}}人观看</span>
                                <span class="live-list-section-right-detail-join"
                                      v-if="item.type === 1 && item.live_status===0">预约</span>
                                <span class="live-list-section-right-detail-join"
                                      v-else-if="item.type === 1 && item.live_status===1">加入</span>
                            </div>
                        </div>
                    </div>
                </van-row>
            </div>
        </div>

        <div class="search-list-section" v-if="article.length > 0">
            <div class="search-list-title">相关资讯<span @click="$router.push({name:'article-list'})">查看更多<img src="/static/img/icon_more.svg" alt=""></span></div>
            <div class="article-list-section">
                <van-row class="article-list-section-box"
                         @click="$router.push({name:'article-detail',params:{'id':item.id}})" v-for="item in article"
                         :key="item.id">
                    <div class="article-list-title" v-html="item.title"></div>
                    <van-col span="16" class="article-list-content">
                        <div class="article-list-content-desc">
                            {{item.desc}}
                        </div>
                        <div class="article-list-content-detail">
                            <div>
                                {{item.created_at}}
                                <span style="margin-left: 8px">{{item.view_count}}人阅读</span>
                            </div>
                        </div>
                    </van-col>
                    <van-col span="8">
                        <img :src="item.cover_img" class="article-list-content-img" alt="">
                    </van-col>
                </van-row>
            </div>
        </div>

        <div class="search-list-section" v-if="short_video.length > 0">
            <div class="search-list-title">相关视频<span @click="$router.push({name:'short-video-list'})">查看更多<img src="/static/img/icon_more.svg" alt=""></span></div>
            <van-row class="short-video-list-section">
                <div class="short-video-list-box" v-for="(item,index) in short_video" :key="item.id"
                     @click="$router.push({name:'short-video-detail',params:{id:item.id}})">
                    <div class="short-video-list-box-img">
                        <van-image
                            fit="cover"
                            :src="item.cover_img"
                            style="width: 100%;height: 100%;border-radius: 6px;"
                        />
                        <div class="short-video-list-box-play-count">
                            <img src="/static/img/video/icon_viedo_watch.svg" alt="">
                            {{item.view_count}}
                        </div>
                    </div>
                    <div class="short-video-list-box-title" v-html="item.title"></div>
                </div>
            </van-row>
        </div>

        <van-empty v-if="empty" description="" image="/static/img/pic_blank_content.svg">
            <template slot="description">
                <div style="text-align: center">没有更多了</div>
                <div style="text-align: center">博医荟持续更新中…</div>
                <div style="text-align: center;margin-top: 10px">先看看其他内容吧！</div>
                <div style="text-align: center;margin-top: 24px">
                    <van-button color="#D3172E" round size="small" style="width: 120px" :to="'/'">
                        返回首页
                    </van-button>
                </div>
            </template>
        </van-empty>
        <Back bottom="14vh"></Back>
    </div>
</template>
<script>
    import Interface from "@/util/interface"
    import Back from '@/components/back'
    export default {
        name: 'search-list',
        components: {
            Back,
        },
        data() {
            return {
                value: "",
                active: "",
                category_id: 0,
                category_child_id: 0,
                banners: [],
                category_index:0,
                autofocus:false,
                categories: [
                    {
                        id:1,
                        name:"综合"
                    },
                    {
                        id:2,
                        name:"按时间"
                    },
                    {
                        id:3,
                        name:"按热度"
                    },
                    {
                        id:4,
                        name:""
                    },
                    {
                        id:5,
                        name:""
                    },
                ],
                categories_child: [],
                course: [],
                short_video: [],
                live: [],
                article: [],
                empty: false,
                order:0,
            }
        },
        methods: {
            onCancel() {
                this.short_video = [];
                this.course = [];
                this.live = [];
                this.article = [];
            },
            onSearch() {
                if(this.value == "高博内训学术专区"){
                    this.$router.push({
                        name:"live-study"
                    })
                    return
                }
                Interface.getData('get', Interface.search, {keyword: this.value,order:this.category_index}).then((res) => {
                    if (res.data.videos != null) {
                        this.short_video = res.data.videos
                    } else {
                        this.short_video = []
                    }
                    if (res.data.articles != null) {
                        this.article = res.data.articles
                    } else {
                        this.article = []
                    }
                    if (res.data.courses != null) {
                        this.course = res.data.courses
                    } else {
                        this.course = []
                    }
                    if (res.data.lives != null) {
                        this.live = res.data.lives
                    } else {
                        this.live = []
                    }
                    if (res.data.videos == null && res.data.articles == null && res.data.courses == null && res.data.lives == null) {
                        this.empty = true
                    } else {
                        this.empty = false
                    }
                })
                sessionStorage.removeItem("search_data")
            },
            go_detail(item) {
                if (item.type != 2) {
                    this.$router.push({'name': 'course-detail', params: {id: item.id}})
                } else {
                    this.$router.push({'name': 'course-column', params: {id: item.id}})
                }
            },
            go_live_detail(item) {
                if (item.type === 2) {
                    this.$router.push({'name': 'live-column', params: {id: item.id}})
                } else if (item.live_status === 6) {
                    this.$router.push({'name': 'live-detail-home', params: {id: item.id}})
                } else {
                    if (item.live_status === 0) {
                        this.$router.push({'name': 'live-detail', params: {id: item.id}})
                    } else {
                        this.$router.push({'name': 'live-detail-home', params: {id: item.id}})
                    }
                }
            }
        },
        created() {
            Interface.getShareInfo(this,"","","")
            let search_data = sessionStorage.removeItem("search_data")
            if (search_data != null){
                this.value = search_data
                this.onSearch()
            }else{
                this.autofocus = true
            }
        }
    }
</script>
<style lang="scss">
    @import "./index";
</style>



// WEBPACK FOOTER //
// src/views/search/index.vue